var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-viewed-services-table"},[_c('v-data-table',{staticClass:"custom-row-hover",attrs:{"no-data-text":"No services in this time frame","hide-default-footer":"","items":_vm.services,"headers":_vm.headers},scopedSlots:_vm._u([{key:"item.name",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(item.firstName)+" "+_vm._s(item.lastName))])]}},{key:"item.totalViews",fn:function(ref){
var item = ref.item;
return [_c('v-chip',{attrs:{"dark":"","color":"#176bf1"}},[_vm._v(_vm._s(item.totalViews))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }